/** Draft Terms of Use (FR) — validate with counsel before relying on as final legal text. */
export const termsFr = {
  title: "Conditions d'utilisation",
  lastUpdatedLabel: 'Dernière mise à jour',
  lastUpdated: '27 juillet 2026',
  sections: [
    {
      heading: '1. Objet',
      paragraphs: [
        "Les présentes Conditions d'utilisation (les « Conditions ») régissent l'accès et l'utilisation de la plateforme Rentalyzer (le « Service »), accessible notamment via app.rentalyzer.ca et domaines connexes, exploitée par DMII / Rentalyzer (« nous », « notre »).",
        "En créant un compte ou en utilisant le Service, vous acceptez d'être lié par ces Conditions. Si vous n'acceptez pas ces Conditions, vous ne devez pas utiliser le Service.",
      ],
    },
    {
      heading: '2. Description du Service',
      paragraphs: [
        "Rentalyzer est un outil logiciel d'analyse de rentabilité et de gestion de projets immobiliers locatifs. Il permet notamment de modéliser des immeubles, des scénarios de financement, de générer des rapports et de partager des analyses avec des tiers que vous choisissez.",
        "Certaines fonctionnalités (par exemple destinées aux courtiers ou prêteurs privés) peuvent être annoncées, restreintes ou déployées progressivement. L'accès à ces modules peut nécessiter une approbation ou une offre commerciale distincte.",
      ],
    },
    {
      heading: '3. Compte utilisateur',
      paragraphs: [
        "Vous devez fournir des informations exactes lors de l'inscription et maintenir la confidentialité de vos identifiants. Vous êtes responsable de toute activité effectuée via votre compte.",
        "Vous devez avoir au moins 18 ans et la capacité juridique de conclure un contrat. Si vous utilisez le Service pour le compte d'une société, vous déclarez être autorisé à lier cette société.",
        "Nous pouvons suspendre ou résilier un compte en cas de violation des présentes Conditions, d'utilisation abusive, de fraude présumée ou pour des motifs de sécurité ou de conformité.",
      ],
    },
    {
      heading: '4. Absence de conseil professionnel',
      paragraphs: [
        "Le Service fournit des outils d'aide à la décision et des estimations fondées sur les données que vous saisissez. Il ne constitue pas un conseil financier, juridique, fiscal, comptable, d'investissement ou de courtage.",
        "Les résultats (cash-flow, taux de capitalisation, simulations SCHL ou conventionnelles, etc.) sont fournis à titre indicatif seulement. Vous devez valider toute décision auprès de professionnels qualifiés et des sources officielles applicables.",
      ],
    },
    {
      heading: '5. Contenu utilisateur et partages',
      paragraphs: [
        "Vous conservez vos droits sur les données et documents que vous téléversez ou saisissez (« Contenu utilisateur »). Vous nous accordez une licence mondiale, non exclusive, pour héberger, traiter, afficher et transmettre ce Contenu dans la mesure nécessaire à la fourniture du Service, y compris lorsque vous activez un partage (lien, invitation, data room, etc.).",
        "Vous êtes seul responsable du Contenu utilisateur, des destinataires que vous invitez et du respect des lois applicables (notamment confidentialité des tiers, NDA, règles professionnelles de courtage).",
        "Les liens de partage peuvent être accessibles sans compte selon la configuration que vous choisissez. Gérez ces liens avec prudence.",
      ],
    },
    {
      heading: '6. Données de marché et amélioration du Service',
      paragraphs: [
        "En utilisant le Service, vous reconnaissez que nous pouvons utiliser des données dérivées de votre Contenu utilisateur, après anonymisation ou agrégation, afin d'améliorer le Service, de produire des statistiques et des indicateurs de marché, et de développer de nouvelles fonctionnalités. Les modalités sont détaillées dans notre Politique de confidentialité.",
      ],
    },
    {
      heading: '7. Usage acceptable',
      paragraphs: [
        'Vous vous engagez à ne pas :',
      ],
      list: [
        'utiliser le Service de manière illégale, frauduleuse ou trompeuse ;',
        "tenter d'accéder sans autorisation aux systèmes, comptes ou données d'autrui ;",
        'perturber, surcharger ou compromettre le fonctionnement du Service ;',
        'extraire, scrapeur ou recopier massivement le contenu ou les données du Service sans autorisation écrite ;',
        "utiliser le Service pour harceler, diffamer ou porter atteinte aux droits de tiers ;",
        "contourner des mesures de sécurité ou des restrictions d'accès (y compris les modules non encore ouverts au public).",
      ],
    },
    {
      heading: '8. Propriété intellectuelle',
      paragraphs: [
        "Le Service, son code, son design, ses marques, logos et contenus fournis par Rentalyzer restent notre propriété ou celle de nos concédants. Aucune licence n'est accordée au-delà de l'usage personnel ou professionnel interne nécessaire pour utiliser le Service conformément aux présentes.",
      ],
    },
    {
      heading: '9. Disponibilité et modifications',
      paragraphs: [
        "Nous nous efforçons d'assurer la disponibilité du Service, sans garantie d'un fonctionnement ininterrompu ou exempt d'erreurs. Des maintenances, pannes ou limitations peuvent survenir.",
        "Nous pouvons modifier, suspendre ou retirer des fonctionnalités, y compris pour des raisons techniques, légales ou commerciales. Nous pouvons aussi mettre à jour ces Conditions ; la version applicable sera indiquée sur la page Conditions d'utilisation. Un usage continu après publication peut constituer une acceptation des modifications, sous réserve du droit applicable.",
      ],
    },
    {
      heading: '10. Limitation de responsabilité',
      paragraphs: [
        "Dans la mesure permise par la loi applicable, le Service est fourni « tel quel » et « selon disponibilité », sans garantie expresse ou implicite (y compris de qualité marchande, d'adaptation à un usage particulier ou d'exactitude des calculs).",
        "Dans la mesure permise par la loi, nous ne serons pas responsables des dommages indirects, accessoires, spéciaux, punitifs ou consécutifs, ni des pertes de profits, de données ou d'occasions d'affaires découlant de l'utilisation ou de l'impossibilité d'utiliser le Service.",
        "Rien dans les présentes n'exclut une responsabilité qui ne peut être limitée ou exclue en vertu du droit du Québec ou du Canada.",
      ],
    },
    {
      heading: '11. Résiliation',
      paragraphs: [
        "Vous pouvez cesser d'utiliser le Service et demander la suppression de votre compte selon les mécanismes disponibles ou en nous contactant. Nous pouvons résilier ou suspendre l'accès en cas de non-respect des Conditions ou pour d'autres motifs légitimes.",
        "Les dispositions qui, par nature, doivent survivre (propriété intellectuelle, limitations de responsabilité, droit applicable) demeurent en vigueur après résiliation.",
      ],
    },
    {
      heading: '12. Droit applicable et litiges',
      paragraphs: [
        "Ces Conditions sont régies par les lois de la province de Québec et les lois fédérales du Canada qui s'y appliquent, sans égard aux règles de conflit de lois. Les tribunaux compétents du district judiciaire de Montréal (Québec) auront compétence exclusive, sous réserve des droits impératifs dont vous pourriez bénéficier à titre de consommateur.",
      ],
    },
    {
      heading: '13. Contact',
      paragraphs: [
        'Pour toute question relative aux présentes Conditions : mmarceau@dmii.ca — Rentalyzer / DMII.',
      ],
    },
  ],
};
